module.exports = __webpack_public_path__ + "static/media/ga.b8cd2c39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ga.svg
// module id = 117
// module chunks = 0